/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import getSubjectsType from '../../utils/get-Subject-Types';

type PropsMateria = {
  $subject: string;
  $color: 10 | 20 | 30 | 40 | 50;
}

export const Container = styled.div<PropsMateria>`
  ${({ theme }) => theme.spacing.articleBody};
  position: relative;

  margin: 16px 0;

  &:before{
    content: '';
    display: block;
    width: 3px;
    height: 100%;
    background: #F05A22;
    position: absolute;
  }

  h4 {
    color: ${({ theme, $subject: subject, $color: color }) => getSubjectsType({ color, subject, theme })};
    ${({ theme }) => theme.typography.h4}
  }

  p.referencia {
    color: #888888;
    font-size: 0.9rem !important;
    line-height: 1.35rem;
  }

  p {
    padding: 0 0 0 1.5em !important;
    line-height: normal;
    ${({ theme }) => theme.typography.quote};
    color: ${({ theme }) => theme.colors.grayscale[20]};

    &:first-of-type{
      margin-top: 0;
    }

    &:not(:last-of-type){
      margin-bottom: .5em;
    }
  }
`;
